import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import Logo from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const googleLogin = () => {
  const redirectUrl = window.location.origin + "/espace";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

function dashFor(user) {
  if (user?.effective_permissions?.length) return "/admin";
  if (user?.roles?.includes("secretary")) return "/secretaire";
  return "/espace";
}

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      const u = await login(email, password);
      navigate(dashFor(u));
    } catch (err) { setError(apiError(err.response?.data?.detail, "E-mail ou mot de passe incorrect")); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:flex flex-col justify-between bg-slate-900 text-white p-12">
        <Logo dark />
        <div>
          <h2 className="font-heading font-semibold text-3xl leading-tight">Votre secrétariat médical, à portée de clic.</h2>
          <p className="mt-4 text-slate-400">Gérez vos demandes, votre planning et vos échanges depuis un espace unique.</p>
        </div>
        <p className="text-sm text-slate-500">© {new Date().getFullYear()} Delya — Suisse</p>
      </div>
      <div className="flex items-center justify-center p-6 sm:p-12">
        <div className="w-full max-w-sm">
          <div className="lg:hidden mb-8"><Logo /></div>
          <h1 className="font-heading font-bold text-2xl text-slate-900">Connexion</h1>
          <p className="mt-2 text-sm text-slate-500">Accédez à votre espace Delya.</p>
          <Button variant="outline" className="w-full mt-6" onClick={googleLogin} data-testid="google-login-btn">
            <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="" className="h-4 w-4 mr-2" />Continuer avec Google
          </Button>
          <div className="my-5 flex items-center gap-3 text-xs text-slate-400"><span className="h-px flex-1 bg-slate-200" />ou<span className="h-px flex-1 bg-slate-200" /></div>
          <form onSubmit={submit} className="space-y-4">
            <div><Label>E-mail</Label><Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1" data-testid="login-email" /></div>
            <div><Label>Mot de passe</Label><Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-1" data-testid="login-password" /></div>
            {error && <p className="text-sm text-rose-600" data-testid="login-error">{error}</p>}
            <Button type="submit" className="w-full bg-primary" disabled={loading} data-testid="login-submit">{loading ? "Connexion..." : "Se connecter"}</Button>
          </form>
          <p className="mt-6 text-sm text-slate-500 text-center">Pas encore de compte ? <Link to="/inscription" className="text-primary font-medium">Créer un compte</Link></p>
        </div>
      </div>
    </div>
  );
}
